import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import global from './global';
import driver from './driver';
import user from './user';
import company from './company';
import investor from './investor';
import suppliers from './suppliers';
import employees from './employees';
import parks from './parks';
import roles from './roles';
import auto from './auto';
import booking from './booking';
import rent from './rent';
import rates from './rates';
import fines from './fines';
import appeals from './appeals';
import dtp from './dtp';
import mechanic from './mechanic';
import notifications from './notifications';
import weekendScheldule from './weekend-schedule';
import workersBoard from './workers-board';
import investorBoard from './investor-board';
import investorReport from './investor-report';
import companyExpenses from './company-expenses';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    global,
    driver,
    user,
    company,
    investor,
    suppliers,
    employees,
    parks,
    roles,
    auto,
    booking,
    rent,
    rates,
    fines,
    appeals,
    dtp,
    mechanic,
    notifications,
    'workers-board': workersBoard,
    'investor-board': investorBoard,
    'investor-report': investorReport,
    'weekend-schedule': weekendScheldule,
    'company-expenses': companyExpenses,
  },
  strict: process.env.NODE_ENV !== 'production',
});
